<template>
  <v-dialog
    v-model="modalIsActive"
    @click:outside="toggleModal"
    max-width="500px"
  >
    <v-card class="process-type-card">
      <v-card-title class="text-h5 justify-center py-4">
        {{
          lang === "ar"
            ? "اختر نوع المعالجة لعملية القبول"
            : "Choose processing type for acceptance"
        }}
      </v-card-title>

      <v-card-text class="py-4">
        <div class="my_input">
          <div class="input_wrapper top_label">
            <label class="form-label mb-3">
              {{ lang === "ar" ? "نوع المعالجة" : "Processing Type" }}
            </label>

            <v-radio-group v-model="processType" row class="justify-center">
              <v-radio
                :label="lang === 'ar' ? 'يدوي' : 'Manual'"
                value="manual"
                color="success"
              ></v-radio>
              <v-radio
                v-if="country.iso3 != 'sau'"
                :label="lang === 'ar' ? 'تلقائي' : 'Automatic'"
                value="automatic"
                color="success"
              ></v-radio>
            </v-radio-group>
          </div>
        </div>
      </v-card-text>

      <v-card-actions class="pb-4">
        <v-spacer></v-spacer>
        <v-btn
          color="#1B5E20"
          dark
          class="px-6"
          @click="submitConfirmForm"
          :disabled="btnIsLoading"
        >
          {{ $t("table.deletedialog.ok") }}
          <span class="btn_loader_model" v-if="btnIsLoading"></span>
        </v-btn>
        <v-btn
          color="#F44336"
          dark
          class="px-6"
          @click="toggleModal"
          :disabled="btnIsLoading"
        >
          {{ $t("table.deletedialog.cancel") }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ProcessTypeModal",

  props: {
    modalIsActive: {
      type: Boolean,
      required: true,
      default: false,
    },
    btnIsLoading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      processType: "manual",
      country: JSON.parse(localStorage.getItem("zoz_dash_country")),
    };
  },

  computed: {
    lang() {
      return this.$store.getters["lang_module/lang"] || "ar";
    },
  },

  methods: {
    toggleModal() {
      this.$emit("toggleModal");
    },
    submitConfirmForm() {
      this.$emit("confirm", this.processType);
    },
  },
};
</script>

<style scoped>
.my_input {
  padding: 10px 20px;
}
.form-label {
  display: block;
  font-weight: 600;
  color: #333;
  text-align: center;
}
.process-type-card {
  padding: 15px;
}
</style>
